<template>
  <div class="static-page">
    <main class="mx-auto max-w-screen-xl px-4 py-12">
      <div class="flex flex-col items-center justify-center max-w-4xl mx-auto mt-24">
        <h1 class="gradient-title">{{ title }}</h1>

        <PricingCards />

        <div class="mt-8">
          <form id="change-plan-form" @submit.prevent="onSubmit">
            <div class="mt-6 flex items-center gap-2">
              <input type="checkbox" id="terms-checkbox" v-model="form.acceptAgreement" class="" />
              <label for="terms-checkbox" class="text-sm text-gray-600">
                I agree to the
                <a
                  href="https://piceditor.io/help/terms-of-service"
                  target="_blank"
                  class="text-blue-600 hover:text-blue-800 underline"
                >
                  Terms of Service
                </a>
              </label>
            </div>
            <button
              type="submit"
              :disabled="!form.acceptAgreement || sending"
              class="btn btn--lg btn--primary w-full mt-12"
            >
              <span>{{ title }}</span>
            </button>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import { useSubscriptionStore } from '$/stores/subscription'
  import { useNotify } from '$/composables/useNotify'
  import PricingCards from '&/landing_pages/PricingCards.vue'

  const route = useRoute()
  const subscriptionStore = useSubscriptionStore()
  const { pushError } = useNotify()
  const sending = ref(false)
  const form = ref({
    acceptAgreement: false,
    planSlug: route.query.plan,
    billingType: route.query.billing_type,
  })

  const onSubmit = function () {
    sending.value = true
    subscriptionStore.changePlan(form.value).catch((err) => {
      const error = err?.response?.data?.error
      if (error) {
        sending.value = false
        pushError(error)
        console.error(error)
      }
    })
  }

  const title = computed(() => {
    if (route.query.plan === 'free') {
      return 'Cancel plan'
    } else if (route.query.plan === 'pro') {
      if (route.query.billing_type === 'monthly') {
        return 'Change to Pro monthly plan'
      } else {
        return 'Change to Pro yearly plan'
      }
    } else if (route.query.plan === 'enterprise') {
      if (route.query.billing_type === 'monthly') {
        return 'Change to Enterprise monthly plan'
      } else {
        return 'Change to Enterprise yearly plan'
      }
    }
    return 'Change plan'
  })
</script>
